import {
    DateFilterValue,
    dateRangeFilterDropdownOptions,
} from "../../constants";
import SingleSelectDropdown from "../SingleSelectFilterToolbarDropdown";

type DateRangeRadioFilterDropdownProps = {
    value: DateFilterValue;
    onChange: (value: DateFilterValue) => void;
};

const defaultFilterValue: DateFilterValue = "this-year";

const DateRangeRadioFilterDropdown = ({
    value,
    onChange,
}: DateRangeRadioFilterDropdownProps) => {
    return (
        <SingleSelectDropdown
            label="Date range"
            options={dateRangeFilterDropdownOptions}
            selected={value}
            name="dateRange"
            onSelect={onChange}
            onReset={() => onChange(defaultFilterValue)}
        />
    );
};

export default DateRangeRadioFilterDropdown;
